import { useCallback } from "react";

import { CharactersTypes } from "@typings/global.types";

export function useFontSizeDetect(text: string, characterWidth: number) {
  const textLength = text.length;

  const getFontSize = useCallback(
    (containerWidth: number): number => {
      const calculatedFontSize =
        (containerWidth - characterWidth) / (textLength * 0.6);
      // round to the nearest number
      const fontSizes = [36, 34, 32, 30, 28, 26, 24, 22, 20, 18, 16, 14];
      const fontSizeIndex = fontSizes.findIndex(
        (size) => size < calculatedFontSize,
      );
      // If calculatedFontSize is less than the smallest font size, return the smallest font size
      if (fontSizeIndex === -1) {
        return fontSizes[fontSizes.length - 1];
      }
      return fontSizes[fontSizeIndex];
    },
    [characterWidth, textLength],
  );

  const calculateCharacterHeightByFontSize = (fontSize: number): number => {
    const allowedSizes = [70, 60, 50, 40];
    const calculatedCharacterWidth = fontSize * 2.5;

    const fontSizeIndex = allowedSizes.findIndex(
      (size) => size < calculatedCharacterWidth,
    );
    return allowedSizes[fontSizeIndex] ?? 40;
  };

  const calculateCharacterWidthByHeight = (
    height: number,
    characterName: CharactersTypes | null,
  ): number => {
    if (characterName === "cato") {
      switch (height) {
        case 70:
          return 100;
        case 60:
          return 86;
        case 50:
          return 71;
        case 40:
          return 57;
        default:
          return height;
      }
    }
    return height;
  };

  return {
    getFontSize,
    calculateCharacterHeightByFontSize,
    calculateCharacterWidthByHeight,
  };
}
